import { Action, createFeatureSelector, createSelector } from '@ngrx/store';
import * as actions from './actions';
import { IIndirectStructure } from '../IIndirectStructure';

export interface State {
    jobs: Array<IIndirectStructure>;
    errors: Array<string>;
}

export const initialState: State = {
    jobs: [],
    errors: []
};

export function reducer(
    state = initialState,
    action: actions.ActionsUnion
): State {
    switch (action.type) {
        case actions.ActionTypes.Reset:
            return initialState;
        case actions.ActionTypes.SetIndirectJobs:
            return {
                ...state,
                jobs: [...action.payload]
            };
        case actions.ActionTypes.UpdateIndirectJobsSuccess:
            const resp = action.payload;
            return {
                ...state,
                jobs: state.jobs
                    .map<IIndirectStructure>(
                        x =>
                            resp.Items.find(
                                y => y.QB_ListID === x.QB_ListID
                            ) || {
                                ...x
                            }
                    ) // update any existing
                    .concat(
                        resp.Items.filter(
                            x =>
                                !state.jobs.find(
                                    y => y.QB_ListID === x.QB_ListID
                                )
                        )
                    ), // add any new
                errors: resp.ErrorMessages
            };
        default:
            return state;
    }
}
const StateFeatureSelector = createFeatureSelector<State>('indirectjobs');
export const getIndirectJobs = createSelector(
    StateFeatureSelector,
    x => x.jobs
);
export const getIndirectJobsErrors = createSelector(
    StateFeatureSelector,
    x => x.errors
);
